import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { buildCatalogIndex } from 'utils/relicVault/catalog';

/**
 * The catalog index, rebuilt only when the catalog itself changes. Indexing 675
 * relics on every render would be felt, so this is the one place it happens.
 */
export function useCollectionCatalog() {
  const guilds = useSelector(state => state.relicVault.guilds);
  const guardians = useSelector(state => state.relicVault.guardians);
  const relics = useSelector(state => state.relicVault.relics);
  const rarities = useSelector(state => state.relicVault.rarities);
  const sheetGrid = useSelector(state => state.relicVault.sheetGrid);
  const badgeCategories = useSelector(state => state.relicVault.badgeCategories);

  return useMemo(
    () => buildCatalogIndex({ guilds, guardians, relics, rarities, sheetGrid, badgeCategories }),
    [guilds, guardians, relics, rarities, sheetGrid, badgeCategories],
  );
}

export default useCollectionCatalog;
